import React from 'react'
import liveInstance from "../liveController/createLiveInstance";
import Barrage from "../gui/_ui/Barrage";

const {
	useSelfInfo,
	useLiveAction,
	useLiveEventCallback
} = liveInstance

// function useLiveBroadcast (evtId, greetMsg, toUserIds, timeout) {
function useLiveBroadcast (params) {
	const [selfInfo] = useSelfInfo()
	const { broadcast } = useLiveAction()
	
	useLiveEventCallback("broadcast", (evtMsg) => {
		switch (evtMsg.event_id) {
			case 'greet':
				Barrage.message(evtMsg.data.message)
				break
			default:
				console.log('___broadcast__bug__')
		}
	})

	return React.useCallback((params) => {
		broadcast({
			event_id: params.event_id,
			data: {
				message: `${selfInfo?.extension?.nickname || selfInfo?.id}说：${params.message}`
			}
		}, [], 0)
	}, [params, selfInfo])
}

export { useLiveBroadcast }
